"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var passport_1 = require("./passport");
var name_1 = require("./name");
var phones_1 = require("./phones");
var addresses_1 = require("./addresses");
var modalHeader_1 = require("../modalHeader");
var occupation_1 = require("./occupation");
var accountReducer = redux_1.combineReducers({
    passport: passport_1.default,
    name: name_1.default,
    addressData: addresses_1.default,
    phones: phones_1.default,
    showNavigation: modalHeader_1.default,
    occupation: occupation_1.default,
});
exports.default = accountReducer;
